/**
 * PTOSummary component - Displays PTO days used and total days of rest
 */

import React from 'react'
import { Typography } from 'antd'
import { PiCalendarBlank } from 'react-icons/pi'
import { useIntl } from 'react-intl'

const { Text } = Typography

interface PTOSummaryProps {
  ptoDaysUsed: number
  durationDays: number
}

export const PTOSummary: React.FC<PTOSummaryProps> = ({ ptoDaysUsed, durationDays }) => {
  const { formatMessage } = useIntl()

  return (
    <div className="pto-summary">
      <PiCalendarBlank className="pto-summary-icon" />
      <Text>
        <strong>{ptoDaysUsed}</strong> {formatMessage({ id: 'energyLevel.ptoDaysLabel' })} → <strong>{durationDays}</strong> {formatMessage({ id: 'energyLevel.daysOfRestLabel' })}
      </Text>
    </div>
  )
}
